import React, { useEffect, useState } from "react";
import Avatar from "../Avatar";
import Typography from "../Typography";
import "./conversationListItem.css";
import { connect } from "react-redux";
import { chatAction, messageAction } from "../../../../../store/action";
import { chatSelector, globalStateSelector } from "../../../../../store/selector";
import { removeElementById, removeSpecialCharactersAndGetLast10 } from "../../utils";
import NameCard from "../../../../theme/theme1/common/components/nameCard/NameCard";
import { RenderInitials } from "../Avatar";
import messageHelper from "../../../../../store/helper/message.helper";
import { formatMessage, formatMessageText } from "../utils/generic";
import { Spinner, Alert } from "modules/theme";
const secondaryTextWrapper = ({ secondaryText }) => {
  return (
    <div
      className="d-flex align-items-center conversation-list__icon"
      style={{ fontSize: "11px", lineHeight: "14px" }}
    >
      {secondaryText}
    </div>
  );
};

function ConversationListItem({
  profile,
  type,
  listData,
  conversationList,
  showAssignButton,
  disposeCustomer,
  isDisposeItem,
  ...props
}) {
  const {
    configProcessor,
    selectedAssignedList,
    dynamicUpdate,
    assignedList,
    unAssignedList,
    canSelectCustomer,
    messageList,
    paginationInfo,
    setAssignScreen,
    typingIndicatorStatus,
    setActiveTab,
    setDisposeScreen,
    messageTagsList,
    joinLoading,
    isConnected,
    isOffline,
    setActiveTabRight
  } = props;
  const [cls, setCls] = useState(null);
  const [SelectedChat, setSelectedChat] = useState(false);

  console.log("typingIndicatorStatus", disposeCustomer);

  useEffect(() => {
    if (listData) {
      if (
        selectedAssignedList &&
        selectedAssignedList.identifier === listData.identifier
      ) {
        setSelectedChat(true);
      } else {
        setSelectedChat(false);
      }
    }
  }, [listData, selectedAssignedList]);

  console.log("messageList12345", listData);

  // console.log("listData12345", listData);

  const primaryText =
    (listData && listData.customer && listData.customer.display) || "Unknown";
  const platform = listData && listData.plateform ? listData.plateform : "";
  let secondaryText = (
    <div
      className="typography__wrapper"
      style={{ textOverflow: "ellipsis" }}
    >
      {/* {listData &&
        listData.message &&
        listData.message.type === "text" &&
        listData.message.content.text} */}

      <div dangerouslySetInnerHTML={{
        __html: formatMessageText(listData &&
          listData.message &&
          listData.message.type === "text" &&
          listData.message.content.text)
      }} />
    </div>
  );
  const msgType =
    (
      // listData.payloadType === "message" &&
      listData.message &&
      listData.message.type) ||
    "";

  console.log('msgType', listData)
  switch (msgType) {
    case "text":
      secondaryText = (
        // <div
        //   className="typography__wrapper"
        //   style={{ textOverflow: "ellipsis", maxWidth: "160px" }}
        // >
        //   <div dangerouslySetInnerHTML={{
        //     __html: formatMessageText(listData &&
        //       listData.message &&
        //       listData.message.content &&
        //       listData.message.content.text)
        //   }} />
        //   {/* {listData &&
        //     listData.message &&
        //     listData.message.content &&
        //     listData.message.content.text} */}
        // </div>
        <div
          className="typography__wrapper"
          style={{
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            // maxWidth: "160px",
            // display: "block"
          }}
        >
          <span
            style={{
              // display: "inline-block",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
            dangerouslySetInnerHTML={{
              __html: formatMessageText(
                listData &&
                listData.message &&
                listData.message.content &&
                listData.message.content.text
              ),
            }}
          />
        </div>

      );
      break;
    case "video":
      secondaryText = (
        <div className="d-flex align-items-center">
          <span class="material-symbols-outlined" style={{ fontSize: '20px' }}>movie</span>
          <div>Video</div>
        </div>
      );
      break;
    case "audio":
      secondaryText = (
        <div className="d-flex align-items-center">
          <span class="material-symbols-outlined" style={{ fontSize: '20px' }}>volume_up</span>
          <div>Audio</div>
        </div>
      );
      break;
    case "image":
      secondaryText = (
        <div className="d-flex align-items-center">
          <span class="material-symbols-outlined" style={{ fontSize: '20px' }}>image</span>
          <div>Image</div>
        </div>
      );
      break;
    case "document":
      secondaryText = (
        <div className="d-flex align-items-center">
          <span class="material-symbols-outlined" style={{ fontSize: '20px' }}>docs</span>
          <div>Document</div>
        </div>
      );
      break;
    default:
      break;
  }
  const image = type === listData && listData.image;
  const status = profile && profile.status;
  const assign = (e) => {
    e.stopPropagation();
    dynamicUpdate({ data: { key: `joinLoading_${selectedAssignedList.identifier}`, value: true } });
    // const newUnassignedList = removeElementById(
    //   unAssignedList,
    //   "identifier",
    //   listData.identifier
    // );
    // dynamicUpdate({
    //   data: { key: "unAssignedList", value: newUnassignedList },
    // });
    if (!messageList[listData.identifier]) {
      configProcessor("getHistory", {
        identifier: listData.identifier,
      });
    }
    configProcessor("sendPayload", {
      ...listData,
      "rmq:pattern": "agent:event",
      payloadType: "event",
      eventMessage: {
        from: "agent",
        type: "assign",
      },
    });
    if (messageTagsList) {
      // Check if there is any entry in messageTagsList with the same teamId as listData.teamId
      const isTeamIdMatched = messageTagsList.some(tag => tag.teamId === listData.teamId);

      if (!isTeamIdMatched) {
        // If no match is found, send the request
        configProcessor(`messageTagList`, { teamId: [listData.teamId] });
      } else {
        // If teamId matches, do not send the request
        console.log("Team ID matches, no request sent.");
      }
    }
    // configProcessor(`messageTagList`, { teamId: [listData.teamId] });
    try {
      messageHelper.iframeEvent("softphoneCallInvited", {
        "from": {
          "number": removeSpecialCharactersAndGetLast10(listData.customer && listData.customer.phoneNumber ? listData.customer.phoneNumber : ""),
        }
      });
    } catch (error) {
      console.log(`iframeEvent error softphoneCallInvited`, error);
    }
    // setAssignScreen(true);
  };

  const selectCustomer = ({ ignorePrevention = false }) => {
    if (!canSelectCustomer && !ignorePrevention) return;
    let loading = false;
    if (!messageList[listData.identifier]) {
      loading = true;
    }
    if (disposeCustomer) {
      // Handle disposeList items
      setDisposeScreen(true); // Set dispose to true
      setActiveTab("dispose"); // Set active tab to Dispose
    } else {
      // Handle assignList items
      setDisposeScreen(false); // Reset disposeScreen to false
      setActiveTab("reply"); // Optionally set the active tab to Assign
    }
    setActiveTabRight("info");

    listData.loading = loading;
    dynamicUpdate({ data: { key: "selectedAssignedList", value: listData } });
    dynamicUpdate({
      data: {
        key: `paginationInfo.${listData.identifier}`,
        value: { ...(paginationInfo[listData.identifier] || {}), page_no: 1 },
      },
    });
    if (listData.identifier !== selectedAssignedList.identifier)
      dynamicUpdate({ data: { key: "showCustomerInfo", value: false } });
    if (!messageList[listData.identifier]) {
      configProcessor("getHistory", {
        identifier: listData.identifier,
      });
    }
    try {
      messageHelper.iframeEvent("softphoneCallInvited", {
        "from": {
          "number": removeSpecialCharactersAndGetLast10(listData.customer && listData.customer.phoneNumber ? listData.customer.phoneNumber : ""),
        }
      });
    } catch (error) {
      console.log(`iframeEvent error softphoneCallInvited`, error);
    }
  };

  useEffect(() => {
    setCls("show-list");
  }, []);

  return (
    <div
      className={`conversation-list ${showAssignButton ? "un-assigned" : "assigned"
        } ${cls} ${SelectedChat ? "conversation-list_selected_conversatation" : ""
        } ${isDisposeItem ? "dispose-item" : ""}`}
      style={{
        // borderTop: "1px solid #ececec",
        borderBottom: "1px solid #ececec",
      }}
      onClick={() => {
        selectCustomer({});
      }}
    >
      <div className="conversation-header__main min-w-0">
        {/* <Avatar text={primaryText} showInitials={true} className='mr-3' imageUrl={image || "https://picsum.photos/200"} status={status} size="lg" showStatus={true} /> */}

        {image ? (
          <Avatar
            text={primaryText}
            className="mr-3 conversation-img"
            imageUrl={image}
            status={status}
            size="lg"
            showStatus={true}
          />
        ) : (
          <div style={{ position: "absolute", left: "12px" }}>
            <RenderInitials
              text={primaryText ? primaryText : "Unknown"}
              type={platform}
            />
          </div>
        )}
        {/* <Avatar
          text={primaryText}
          className="mr-3 conversation-img"
          // imageUrl={image || "/images/user-profile.png"}
          imageUrl={image ? image : renderInitials(primaryText)}
          status={status}
          size="sm"
          showStatus={true}
        /> */}
        <div className="conversation-header__block1">
          {/* <p className="conversation-header__block1-name">{primaryText}</p> */}
          <p className="conversation-header__block1-name">{primaryText}</p>
          <p className="conversation-header__block1-time"></p>
        </div>
        {/* <p className="conversation-header__block2">Live Chat</p> */}
        <div className="conversation-header__block3">
          {/* <p className="conversation-header__block3-msg">{secondaryText}</p> */}
          {/* <p className="conversation-header__block3-msg"> {secondaryText}</p> */}
          {/* {SelectedChat || !typingIndicatorStatus ? (
            <p className="conversation-header__block3-msg">{secondaryText}</p>
          ) : (
            <TypingIndicatorBubble />
          )} */}
          <div className="conversation-header__block3-message">
            {/* {secondaryText} */}
            {typingIndicatorStatus ? (
              <div className="typing-indicator">Typing...</div>
            ) : (
              secondaryText
            )}
          </div>

          {showAssignButton && (
            <button
              className={
                "conversation-list__unread-count conversation-list__assign-btn"
              }
            >
              <span
                className={`conversation-list__unread-count-text`}
                onClick={(e) => {
                  (isOffline || !isConnected) ? (
                    Alert.error("You are Offline")
                  ) : (
                    assign(e)
                  )
                }}
              >
                {joinLoading ? (
                  <Spinner
                    style={{
                      height: "3px",
                      marginTop: "-15px",
                      padding: "10px",
                      marginBottom: "10px",
                    }}
                  />
                ) : (
                  "Join"
                )}
              </span>
            </button>
          )}
        </div>
        {/* <div className='d-flex flex-column min-w-0'>
          <Typography text={primaryText} />
          <Typography text={
            secondaryTextWrapper({secondaryText})
          } variant='secondary' />
        </div> */}
      </div>

      {/* <button className={`conversation-list__unread-count ${showAssignButton?'conversation-list__unread-count-showhide':''}`}>
          <span className={`conversation-list__unread-count-text`}>{listData && listData.message && listData.message.count}</span>
        </button> */}
    </div>
  );
}

const stateToProps = (state, ownProps) => {
  // Fetch the required state properties first
  const selectedAssignedList = chatSelector.getChatDynamic(
    state,
    "selectedAssignedList"
  );

  return {
    selectedAssignedList,
    assignedList: chatSelector.getChatDynamic(state, "assignedList"),
    unAssignedList: chatSelector.getChatDynamic(state, "unAssignedList"),
    messageList: chatSelector.getChatDynamic(state, "messageList"),
    paginationInfo: chatSelector.getChatDynamic(state, "paginationInfo"),
    typingIndicatorStatus: chatSelector.getTypingStatus(
      state,
      ownProps.listData.identifier
    ),
    messageTagsList: chatSelector.getChatDynamic(state, "messageTagsList"),
    joinLoading: chatSelector.getChatDynamic(state,
      `joinLoading_${selectedAssignedList.sessionId}`
    ) || false,
    isConnected: globalStateSelector.getIsConnected(state),
    isOffline: globalStateSelector.getIsOffline(state),
  };
};

// const stateToProps = (state, ownProps) => ({
//   assignedList: chatSelector.getChatDynamic(state, "assignedList"),
//   unAssignedList: chatSelector.getChatDynamic(state, "unAssignedList"),
//   messageList: chatSelector.getChatDynamic(state, "messageList"),
//   selectedAssignedList: chatSelector.getChatDynamic(
//     state,
//     "selectedAssignedList"
//   ),
//   paginationInfo: chatSelector.getChatDynamic(state, "paginationInfo"),
//   typingIndicatorStatus: chatSelector.getTypingStatus(
//     state,
//     ownProps.listData.identifier
//   ),
//   messageTagsList: chatSelector.getChatDynamic(state, "messageTagsList"),
//   joinLoading: chatSelector.getChatDynamic(state,
//     `joinLoading_${selectedAssignedList.sessionId}`
//   ) || false,
// });

const dispatchToProps = (dispatch) => ({
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: (type, messageData) => {
    dispatch(chatAction.dynamicUpdate(type, messageData));
  },
  setDisposeScreen: (data) => {
    dispatch(chatAction.setDisposeScreen(data));
  },
  setActiveTab: (data) => {
    dispatch(chatAction.setActiveTab(data));
  },
  setActiveTabRight: (data) => {
    dispatch(chatAction.setActiveTabRight(data));
  },
});
export default connect(stateToProps, dispatchToProps)(ConversationListItem);



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/conversationListItem/conversationListItem.js